export default "__VITE_ASSET__BFk$iW_o__"